var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-breadcrumb",
        {
          staticClass: "breadcrumb",
          attrs: { "separator-class": "el-icon-arrow-right" },
        },
        [_c("el-breadcrumb-item", [_vm._v("个人信息")])],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "user-info" },
        [
          _c(
            "el-form",
            {
              staticStyle: { width: "500px" },
              attrs: { "label-width": "120px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("navbar.LoginName") } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.userInfo.loginName,
                      callback: function ($$v) {
                        _vm.$set(_vm.userInfo, "loginName", $$v)
                      },
                      expression: "userInfo.loginName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("navbar.ChineseName") } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.userInfo.userNameCn,
                      callback: function ($$v) {
                        _vm.$set(_vm.userInfo, "userNameCn", $$v)
                      },
                      expression: "userInfo.userNameCn",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("navbar.defaultRole") } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.deploy === "vessel" ? true : false,
                      },
                      model: {
                        value: _vm.userInfo.defaultRoleId,
                        callback: function ($$v) {
                          _vm.$set(_vm.userInfo, "defaultRoleId", $$v)
                        },
                        expression: "userInfo.defaultRoleId",
                      },
                    },
                    _vm._l(_vm.userInfo.sysRoleList, function (item) {
                      return _c("el-option", {
                        attrs: { label: item.roleName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("navbar.AffiliatedOrganization") } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.userInfo.officeName,
                      callback: function ($$v) {
                        _vm.$set(_vm.userInfo, "officeName", $$v)
                      },
                      expression: "userInfo.officeName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("navbar.position") } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: "",
                      value:
                        _vm.language === "zh"
                          ? _vm.userInfo.roleNameCn
                          : _vm.userInfo.roleNameEn,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("navbar.Numberofvisits") } },
                [_c("el-input", { attrs: { disabled: "" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("navbar.Recentlyloggedin") } },
                [_c("el-input", { attrs: { disabled: "" } })],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }